import { UntypedFormGroup } from '@angular/forms';
import { QuestionBase } from '@jump-tech-frontend/domain';
import { ExampleImage } from '@jump-tech-frontend/question-components';
import { ImageAssetFactory } from '../domain/card';
import { ImageAssetType } from '../domain/types';

interface ResolvedAsset {
  type: ImageAssetType;
  size?: string;
  getSrc(): string;
}

function toExample(asset: ResolvedAsset): ExampleImage {
  return asset.type === ImageAssetType.ICON
    ? { kind: 'icon', name: asset.getSrc(), size: asset.size }
    : { kind: 'image', src: asset.getSrc() };
}

export function exampleImagesFor(
  factory: ImageAssetFactory,
  question: QuestionBase<unknown>,
  form: UntypedFormGroup
): ExampleImage[] {
  return (factory.create(question.image, form) as unknown as ResolvedAsset[]).map(toExample);
}
